<script>
import { authComputed } from '@state/helpers'

export default {
  components: {},
  data() {
    return {
      config: {
        handler: this.handleRightBarClick,
        middleware: this.middleware,
        events: ['click'],
      },
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    hide() {
      this.$parent.toggleRightSidebar()
    },
    handleRightBarClick(e, el) {
      this.$parent.hideRightSidebar()
    },
    middleware(event, el) {
      return !event.target.classList.contains('toggle-right')
    },
  },
}
</script>

<template>
  <div>
    <!-- Right Sidebar -->
    <div v-click-outside="config" class="right-bar">
      <div class="rightbar-title">
        <a href="javascript:void(0);" class="right-bar-toggle float-right" @click="hide">
          <i class="fe-x noti-icon"></i>
        </a>
        <h4 class="m-0 text-white">Company Details</h4>
      </div>
      <div class="slimscroll-menu">
        <!-- User box -->
        <div class="user-box">
          <div class="user-img">
            <img
              src="@assets/images/users/admin.png"
              alt="user-img"
              title="Mat Helme"
              class="rounded-circle img-fluid"
            />

          </div>

          <h5>
            <a href="javascript: void(0);">Admin</a>
          </h5>
          <p class="text-muted mb-0">
            <small>info@99gift.in</small>
          </p>
        </div>
        <div class="p-3">
          <div class="inbox-widget">
            <div class="inbox-item">
              <div class="inbox-item-img">
                <img src="@assets/images/users/profileee.png" class="rounded-circle" alt />
              </div>
              <p class="inbox-item-author">
                <a href="javascript: void(0);" class="text-dark">UJJWAL</a>
              </p>
              <p class="inbox-item-text">Technical Head</p>
            </div>



          </div>
          <!-- end inbox-widget -->

          <!-- end .p-3-->
        </div>
      </div>
      <!-- end slimscroll-menu-->
    </div>
    <!-- /Right-bar -->

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
  </div>
</template>

<style lang="scss"></style>
